export const DEEPGRAM_PROXY = "wss://api.deepgram.com";
export const DEEPL_PROXY = "https://translate.livetranslate.fiodorov.es/api";
